import { render } from "./LegalAdvice.vue?vue&type=template&id=5670edf5&scoped=true&ts=true"
import script from "./LegalAdvice.vue?vue&type=script&lang=ts"
export * from "./LegalAdvice.vue?vue&type=script&lang=ts"

import "./LegalAdvice.vue?vue&type=style&index=0&id=5670edf5&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5670edf5"]])

export default __exports__